<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';
// import draggable from 'vuedraggable'

export default {
	name: "AppPubPostCat",
	extends: Base,
	// components: {
	// 	draggable,
	// },
  data(){
    return {
		Name:"AppPubPostCat",
		mrLevel: {},
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)
		this.refreshData()
	},
  watch:{
    '$route.query'(){
		this.refreshData()
	},
    'filter.level'(){
		this.search()
	},
  },
  
	methods:{
		endDrag(){
            BOGen.apirest('/'+this.Name, {data:this.data.data,type:'sort'}, (err,resp)=>{
            console.log(resp)
            }, "POST");
        }
	}
};
</script>

<template>
	<div class="container-fluid">
		<PageTitle></PageTitle>
		
		<!-- ======================================================================== 
			LIST DATA
		============================================================================= -->
		<div class="row" v-if="!$route.params.id">
          <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
             <div class="card">
                <div class="card-body">
	                <VForm @resp="search">
						<div class="row">
							<div class="col-sm-5">
								<h5 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h5>
							</div>
							<div class="col-sm-3">
							</div>
							<div class="col-sm-3">
								<div class="form-group mb-0">
                                    <div class="input-group">
                                       <input type="text" v-model="filter.search"  class="form-control" placeholder="Search...">
                                       <div class="input-group-append">
                                          <button class="btn btn-info" type="button" @click="search()"><i class="fas fa-search"></i></button>
                                       </div>
                                    </div>
                                 </div>
							</div>
							<div class="col-sm-1">
								<router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
							</div>
						</div>
					</VForm>
                </div>
                <div class="table-responsive ajax-table">
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th>#</th>
								<th><SortField name="abc_name_en"></SortField></th>
								<th>Status</th>
								<th width="120px">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(v,k) in data.data" :key="k">
								<td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
								<td>{{v.abc_name_en}}</td>
								<td><StatusLabel :status="v.status"></StatusLabel></td>
								<td class="btn-action text-center">
									<router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="ti-marker-alt"></i></router-link>
									<!-- <a href="javascript:;" class="icon_action" @click="changeStatus(k)" v-tooltip="'Change Status'"><i class="icon-settings"></i></a>
									<a href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-tooltip="'Remove'"><i class="ti-trash"></i></a> -->
								</td>
							</tr>
							<tr v-if="NotFound">
								<td colspan="99">
									<h3 class="tc">{{NotFound}}</h3>
								</td>
							</tr>
							<tr v-if="data.data===false">
								<td colspan="99">
									<LoadingSpinner light></LoadingSpinner>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="panel-body">
					<div class="pull-right">
						<Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
					</div>
				</div>
             </div>
          </div>
       </div>

		<!-- ======================================================================== 
			FORM CRUD	
		============================================================================= -->
		<div class="card" v-if="$route.params.id">
			<VForm @resp="submitForm" method="post">
				<div class="card-body">
					<div class="row mb-3">
                      <div class="col-md-8">
                         <h5 class="card-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h5>
                      </div>
                   </div>
					<div class="info"></div>
					<div class="row">
						<div class="col-6">
							<BoField name="abc_name_en" v-model="row.abc_name_en"></BoField>
							<BoField name="abc_meta_title_en" v-model="row.abc_meta_title_en"></BoField>
							<BoField name="abc_meta_keyword_en">
								<TagsInput name="abc_meta_keyword_en" style="display:block" v-model="row.abc_meta_keyword_en" :attr="validation('abc_meta_keyword_en')"></TagsInput>
							</BoField>
							<BoField mandatory name="abc_meta_desc_en">
								<textarea rows="4" name="abc_meta_desc_en" required="required" title="Input meta description." minlegth="3" maxlegth="300" v-model="row.abc_meta_desc_en" v-bind="validation('abc_meta_desc_en')"
									class="form-control"></textarea>
							</BoField>							
							<BoField name="abc_is_active">
								<div class="row">
									<radio name="abc_is_active" v-model="row.abc_is_active" option="Y" :attr="validation('abc_is_active')">Active</radio>
									<radio name="abc_is_active" v-model="row.abc_is_active" option="N">Inactive</radio>
								</div>
							</BoField>
						</div>
						<div class="col-6">
							<BoField name="abc_name_id" v-model="row.abc_name_id"></BoField>
							<BoField name="abc_meta_title_id" v-model="row.abc_meta_title_id"></BoField>
							<BoField name="abc_meta_keyword_id">
								<TagsInput name="abc_meta_keyword_id" style="display:block" v-model="row.abc_meta_keyword_id" :attr="validation('abc_meta_keyword_id')"></TagsInput>
							</BoField>
							<BoField mandatory name="abc_meta_desc_id">
								<textarea rows="4" name="abc_meta_desc_id" title="Input meta description." minlegth="3" maxlegth="300" v-model="row.abc_meta_desc_id" v-bind="validation('abc_meta_desc_id')"
									class="form-control"></textarea>
							</BoField>
						</div>
						<div class="col-12">
							<div class="text-left">
								<button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit <i class="icon-arrow-right14 position-right"></i></button>
							</div>
						</div>
					</div>
				</div>
			</VForm>
		</div>
	</div>
</template>
